import type { ModelContext } from '@assistant-ui/react';

import { AgentContext } from '#plugin-chat/contexts/AgentContext.ts';
import { useAgentRegistration } from '#plugin-chat/hooks/useAgentRegistration.ts';

interface AgentProps extends ModelContext {
  name?: string;
  description?: string;
  completeTaskTool?: React.ReactNode;
  abortTaskTool?: React.ReactNode;
}

/**
 * Agent provides model context resolution for AI assistants.
 * Supports dynamic tool parameters via factory functions that access current conversation state.
 */
export function Agent({
  name = 'Cognite Atlas AI\u2122',
  description = '',
  system = '',
  priority = 10,
  callSettings = { temperature: 0 },
  children,
}: React.PropsWithChildren<AgentProps>) {
  const isEnabled = useAgentRegistration(name, {
    name,
    description,
    getModelContext: () => ({
      system,
      callSettings,
      priority,
    }),
  });

  return <AgentContext value={{ isEnabled }}>{children}</AgentContext>;
}
